<template>
  <div ref="root" :class="$style['adl-components-ui__chart-time-series']">
    <mce-hover-flag
      v-if="mouse && !hideMouseHover"
      :x="mouse.pageX"
      :y="mouse.pageY"
      style="border-radius: 5px"
    >
      <slot name="tooltipText"></slot>
    </mce-hover-flag>

    <mce-legend hideTopBorder :horizontal="true">
      <template v-for="(d, i) in legendItems">
        <mce-legend-item
          v-if="d"
          :label="d"
          :key-type="legendKeyType"
          :color="color[i]"
        ></mce-legend-item>
      </template>
    </mce-legend>

    <div :class="$style['graph-bar']" :style="mainbar">
      <mce-pointer v-model="mouse" />
      <template v-for="(d, i) in addStyleinInputData">
        <div :class="$style['graph-bar-child']" :style="d.style"></div>
      </template>
    </div>

    <mce-x-axis
      scale-type="time"
      :labels="{ axis: 'Year' }"
      :domain="FormateddomainX"
      :range="changeRangeX"
      :label-format="timeFormat"
    ></mce-x-axis>
  </div>
</template>

<script>
import Vue from "vue";
import { MceLegend, MceLegendItem, MceLegendGroup } from "@mce/legend";
import { scaleTime } from "d3-scale";
import MceXAxis from "@mce/x-axis";
import MceHoverFlag from "@mce/hover-flag";
import McePointer from "@mce/pointer";
import { timeFormat } from "d3-time-format";

import _ from "lodash";
export default Vue.extend({
  name: "AdlChartTimeSeries",
  components: {
    MceXAxis,

    MceLegend,
    MceLegendItem,
    MceLegendGroup,
    MceHoverFlag,
    McePointer,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    color: {
      type: Array,
      default: () => [],
    },

    legendItems: {
      type: Array,
      default: () => [],
    },
    legendKeyType: {
      type: String,
      default: () => "bar",
    },
    hideMouseHover: {
      type: Boolean,
    },
    domainX: {
      type: Array,
      required: true,
    },

    axisLeftWidth: {
      type: Number,
      default: 0,
    },
    axisRightWidth: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    tooltipWidth: {
      type: Number,
      default: 0,
    },
    tooltipheight: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      rootHeight: 0,
      rootWidth: 0,
      mouseDataLine: {},
      mouseDataTitle: {},
      mouse: null,
      timeInterval: 12,
    };
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", _.debounce(this.onResize, 100));
  },
  beforeDestroy() {
    window.removeEventListener("resize", _.debounce(this.onResize, 100));
  },

  computed: {
    FormateddomainX() {
      return [
        new Date("January 1," + this.domainX[0]),
        new Date("December 31," + this.domainX[1]),
      ];
    },
    timeFormat() {
      if (this.domainX[1] - this.domainX[0] < 4) {
        return timeFormat("%m/%Y");
      } else {
        return timeFormat("%Y");
      }
    },
    mainbar() {
      return `background-color : ${this.color[0]} ; width : ${this.width}px ; margin-top:${this.height}px `;
    },
    xScale() {
      const scale = scaleTime()
        .domain(this.FormateddomainX)
        .range(this.changeRangeX);
      return scale;
    },

    addStyleinInputData() {
      let totalElement = this.data.length;
      for (let i = 0; i < totalElement; i++) {
        let isYearInRange = this.isYearInTimeRange(
          this.data[i].startYear,
          this.data[i].endYear,
          this.data[i].startMonth,
          this.data[i].endMonth
        );
        if (isYearInRange[0] == 0 || isYearInRange[1] == 0) {
          continue;
        }
        let width =
          this.xScale(new Date(isYearInRange[1], isYearInRange[3], 0)) -
          this.xScale(new Date(isYearInRange[0], isYearInRange[2] - 1, 1));
        this.data[i].style = {
          backgroundColor: this.color[1],
          width: `${width}px`,
          left: `${this.xScale(
            new Date(isYearInRange[0], isYearInRange[2] - 1, 1)
          )}px`,
        };
      }
      return this.data;
    },

    width() {
      return this.rootWidth - this.axisRightWidth;
    },

    domainXLabel: function () {
      return [...Array(this.data.length + this.tickX).keys()];
    },

    changeRangeX() {
      if (this.width == 0) {
        return [0, 1];
      } else {
        return [0, this.width];
      }
    },
  },
  watch: {
    mouse: {
      handler() {
        if (this.mouse) {
          let linedata = this.onMouseMove();
          this.$emit("setTooltipData", linedata);
          this.mouse.pageY = this.mouse.pageY - this.tooltipheight;
          if (!(this.rootWidth - this.mouse.pageX > this.tooltipWidth)) {
            // this.mouse.pageX = this.mouse.pageX - this.tooltipWidth;
          }
        } else {
          this.mouseDataLine = null;
          this.mouseDataTitle = null;
        }
      },
    },
  },

  methods: {
    isYearInTimeRange(startYear, endYear, startMonth, endMonth) {
      let years = [0, 0];
      if (endYear >= this.domainX[0] && startYear <= this.domainX[1]) {
        if (endYear > this.domainX[1]) {
          years[1] = this.domainX[1];
          years[3] = 12;
        } else {
          years[1] = endYear;
          years[3] = endMonth;
        }
      } else {
        years[1] = 0;
      }

      if (startYear <= this.domainX[1] && years[1] > 0) {
        if (startYear < this.domainX[0]) {
          years[0] = this.domainX[0];
          years[2] = 1;
        } else {
          years[0] = startYear;
          years[2] = startMonth;
        }
      } else {
        years[0] = 0;
      }

      return years;
    },
    invertScaleBandX(x) {
      return scaleTime()
        .domain(this.xScale.range())
        .range(this.xScale.domain())(x);
    },
    getXValue() {
      return this.invertScaleBandX(this.mouse.offsetX);
    },
    onMouseMove() {
      const _dataIndex = this.getXValue();
      return {
        position: this.mouse,
        id: _dataIndex,
      };
    },
    onResize() {
      let rootElement = this.$refs.root;
      if (rootElement !== undefined) {
        this.rootHeight = Number(rootElement.clientHeight) || this.rootHeight;
        this.rootWidth = Number(rootElement.clientWidth) || this.rootWidth;
        if (this.rootWidth % 2 != 0) {
          this.rootWidth = this.rootWidth - 1;
        }
      }
    },
  },
});
</script>

<style lang="scss" module>
@import "@mds/constants";
@import "@mds/typography";
.adl-components-ui__chart-time-series {
  @import "@mce/visual-language";

  .graph-bar {
    position: relative;
    height: 20px;
    border-radius: 20px;
    margin-bottom: $mds-space-4-x;
  }
  .graph-bar-child {
    border-radius: 20px;
    position: absolute;
    top: 0;
    height: 20px;
  }
}
</style>
